import HttpService from './HttpService'
import { params } from '../localData'

export const fetchPlans = async ({ accessToken, customerId, promoData }) => {
  const { plans } = await HttpService.post(
    `v4/secureonboarding/user/${customerId}/account/plans`,
    promoData,
    {
      headerName: params.httpHeaders.auth,
      headerValue: 'Bearer ' + accessToken,
    }
  )
  return plans
}



// WEBPACK FOOTER //
// ./src/services/plansService.js